export default __webpack_public_path__ + "static/media/bim_logo.7fe0e591.svg";